import { ModalEditRegsterStyled } from "../../../../Modal/ModalEditRegister/styles";
import { Modal } from "../../../../Modal";
import { Input } from "../../../../../assets/styles/Input";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Dispatch, SetStateAction, useContext } from "react";
import { ButtonStyled } from "../../../../Button/styles";
import { forgotSenhaSchema, iForgotSenhaData } from "./forgotSenha.schema";
import { UserContext } from "../../../../../providers/UserContext";

type iModalRegister = {
	showForgotSenha: boolean;
	setShowForgotSenha: Dispatch<SetStateAction<boolean>>;
};

export const ModalResetPassword = ({
	showForgotSenha,
	setShowForgotSenha,
}: iModalRegister) => {
	const { forgotSenha } = useContext(UserContext);

	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm<iForgotSenhaData>({
		resolver: zodResolver(forgotSenhaSchema),
	});

	const submitForgotSenha = (forgotSenhaData: iForgotSenhaData) => {
		forgotSenha(forgotSenhaData);
		setShowForgotSenha(false);
	};

	return (
		<ModalEditRegsterStyled>
			{showForgotSenha && (
				<Modal showModal={setShowForgotSenha}>
					<div className="card">
						<h1>Recuperar senha</h1>
						<div className="form">
							<form onSubmit={handleSubmit(submitForgotSenha)}>
								<Input
									type="email"
									id="email"
									placeholder="Email"
									{...register("email")}
									alt="Email"
								/>
								{errors.email && <p>{errors.email.message}</p>}
								<abbr title="Enviar">
									<ButtonStyled type="submit">Enviar</ButtonStyled>
								</abbr>
							</form>
						</div>
					</div>
				</Modal>
			)}
		</ModalEditRegsterStyled>
	);
};
